import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dayjs from 'dayjs';
import {
  Popconfirm, notification, Dropdown, Menu, Drawer, Tooltip,
} from 'antd';
import {
  LoadingOutlined, EditOutlined, CaretRightOutlined, CaretDownOutlined, CopyOutlined, UserOutlined,
} from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import UserActions from '@Actions/userActions';
import Helpers from '@Apis/helpers';
import closeIcon from '@Images/icons/icon-close-blue.png';
import Attachment from '@Components/Common/Attachment';
import AttachmentActions from '@Actions/attachmentActions';
import ViewCustomFields from '@Components/Common/CustomField/ViewCustomFields';
import Constants from '@Apis/constants';
import ActivityLog from '@Components/Common/ActivityLog';
import WorkFlowTimeLine from '@Components/Common/WorkFlowTimeLine';
import './style.scss';
import Crown from '@Images/crown2.png';
import AnalyticsActions from '@Actions/application/analyticsActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { v4 as uuidv4 } from 'uuid';
import TagSelector from '@Components/Common/Selector/TagSelector';
import { GetPurchaseIndent, UpdatePurchaseIndentStatus, PurchaseIndentApprovalWorkflow } from '../../../../modules/purchase/purchaseIndent';
import ViewLoadingSkull from '../../../Common/ViewLoadingSkull';
import { SERVICE_ENDPOINT } from '../../../../apis/constants';
import PurchaseIndentLines from './PurchaseIndentLines';
import POForm from '../../PurchaseOrders/POForm';

function ViewPurchaseIndent({
  user,
  isQuickView,
  selectedPurchaseIndent,
  getPILoading,
  getPurchaseIndent,
  match,
  updatePIStatus,
  updatePIStatusLoading,
  getAttachmentByIdLoading,
  updateAttachmentLoading,
  updateAttachment,
  getAttachmentById,
  history,
  selectedPIId,
  updatePIWorkflowStepLoading,
  updatePIWorkflowStep,
  downloadDocument,
  MONEY,
  priceMasking,
  getPurchaseIndentSuccess,
}) {

  const [state, setState] = useState({
    piId: null,
    visibleColumns: {
      PRODUCT: {
        label: 'Product',
        visible: true,
        disabled: true,
      },
      QUANTITY: {
        label: 'Quantity',
        visible: true,
        disabled: true,
      },
      UNIT: {
        label: 'Unit',
        visible: true,
        disabled: true,
      },
      REQ_BY_DATE: {
        label: 'Required By Date',
        visible: true,
        disabled: true,
      },
      PLAN_NUMBER: {
        label: 'Planning Number',
        visible: true,
        disabled: true,
      },
    },
    currentUpdate: '',
    sendForApprovalConfirmation: false,
    selectedTags: [],
    fileList: [],
    getterExecuted: false,
    createPODrawer: false,
  });
  const [call, setCall] = useState(false);
  const {
    visibleColumns,
    piId,
    currentUpdate,
    selectedTags,
    fileList,
    createPODrawer,
  } = state;
  const updateState = (newStates) => {
    setState((oldStates) => ({
      ...oldStates,
      ...newStates,
    }));
  };
  useEffect(() => {
    const routePiId = match?.params?.piId;
    const idToUse = routePiId || selectedPIId;
    if (idToUse) {
      updateState({ piId: idToUse });

      getPurchaseIndent({ url: SERVICE_ENDPOINT.GET_PURCHASE_INDENT({ pi_id: idToUse }).url });
    }

    return () => {
      getPurchaseIndentSuccess(null);
    }
  }, [selectedPIId, call]);

  const handleFileChange = (fileListData) => {

    const fileList = fileListData?.fileList?.map((item) => ({
      ...item,
      url: item?.response?.response?.location || item?.url,
    }));
    const attachments = fileList?.map((attachment) => ({
      url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
    }));

    if (fileListData?.file.status === 'done') {
      const payload = {
        entity_id: piId,
        entity_name: 'purchase_indent',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(piId, 'purchase_indent', () => {
          updateState({
            isGetAttachment: true,
          });
        });
      });
    }
    if (fileListData?.file.status === 'removed') {
      const payload = {
        entity_id: piId,
        entity_name: 'purchase_indent',
        attachments,
      };
      updateAttachment(payload, () => {
        getAttachmentById(piId, 'purchase_indent', () => {
          updateState({
            isGetAttachment: true,
          });
        });
      });
    }

    updateState({
      fileList: attachments.length > 0 ? attachments : [],
    });
  };

  const fixedMenuBar = user?.side_menu_bar_type === 'FIXED';

  const HideAdhocApprovals = () => {
    if (selectedPurchaseIndent?.workflow_steps) {
      const steps = Object.values(selectedPurchaseIndent?.workflow_steps)?.filter((step) => step !== null);
      const pendingSteps = steps?.filter((step) => step?.status === 'PENDING');
      return steps.length < 10 && pendingSteps.length === steps.length;
    }
    return false;
  };

  // If User is from store person user can see PI.
  // User should be from Purchase Indents Department.
  // If user is from store or Issuer department then he can create PO.
  // const isDocumentDepartmentAccessible = (record) => {
  //   const tenantId = record?.tenant_id;
  //   const { userTenantDepartmentId, tenantDefaultStoreId } = Helpers.getUserTenantDepartmentIds(user, tenantId);

  //   return (
  //     record?.tenant_department_id == userTenantDepartmentId || record?.tenant_department_id == null || userTenantDepartmentId == tenantDefaultStoreId
  //   );
  // };

  useEffect(() => {
    if (selectedPurchaseIndent) {
      const tags = selectedPurchaseIndent?.tags?.length > 0 ? selectedPurchaseIndent?.tags : [];
      updateState({ selectedTags: tags });
      updateState({ fileList: selectedPurchaseIndent?.attachments });
    }

  }, [selectedPurchaseIndent])

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  return (
    <div className={`view-document__wrapper ${!isQuickView ? 'view-document__wrapper-page' : ''}`}>
      {getPILoading ? (
        <ViewLoadingSkull isQuickView={isQuickView} fixedMenuBar={fixedMenuBar} />
      ) : (
        <div className='ant-row'>
          <div className={`${fixedMenuBar ? 'ant-col-md-16' : 'ant-col-md-17'} ant-col-xs-24`}>
            <div className={`view-left__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
              <div className="view-document__title">
                <div className="view-document__title-number-wrapper">
                  <H3Text text={selectedPurchaseIndent?.pi_number || 'N/A'} className="view-document__title-number" />
                  <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedPurchaseIndent?.status)?.color }}>
                    {selectedPurchaseIndent?.status?.replaceAll('_', ' ')}
                  </div>
                  {selectedPurchaseIndent?.purchase_status && <div className="view-document__title-status" style={{ backgroundColor: Helpers.getStatusColor(selectedPurchaseIndent?.purchase_status)?.color }}>
                    {selectedPurchaseIndent?.purchase_status?.replaceAll('_', ' ')}
                  </div>}
                </div>
                {!isQuickView && (
                  <div className="view-document__title-actions">
                    <div className="action-buttons">
                      {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.UPDATE, user) && selectedPurchaseIndent?.status !== 'COMPLETED' && (
                        <H3Text
                          text={(
                            <div onClick={() => {
                              if (!!selectedPurchaseIndent?.reference_purchase_orders?.length) {
                                notification.error({
                                  message: 'This Purchase Indent cannot be updated as it has linked Purchase Orders.',
                                  description: 'Please delete all linked Purchase Orders first.',
                                  placement: 'top',
                                  duration: 6,
                                });
                              } else {
                                history.push(`/purchase/purchase-indent/update/${piId}`);
                              }
                            }}
                            >
                              <EditOutlined />
                            </div>
                          )}
                          className="action-button hide__in-mobile"
                        />
                      )}
                      <H3Text
                        text={
                          <FontAwesomeIcon icon={faPrint} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
                        }
                        onClick={() => downloadDocument({
                          url: `${Constants.PURCHASE_INDENT}/download?pi_id=${piId}`,
                          document_type: 'PURCHASE_INDENT',
                          document_number: selectedPurchaseIndent?.pi_number,
                          key: uuidv4(),
                        })}
                        className="action-button"
                      />
                    </div>
                    <div className="action-buttons">
                      {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) && (
                        <Tooltip
                          placement="topLeft"
                          title="Make a Copy"
                        >
                          <CopyOutlined
                            className="action-button"
                            style={{
                              justifyContent: 'center',
                              fontSize: '16px',
                            }}
                            onClick={() => {
                              history.push(`/purchase/purchase-indent/create?clonePiId=${piId}`);
                            }}
                          />
                        </Tooltip>
                      )}
                      {['DRAFT'].includes(selectedPurchaseIndent?.status) && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) && (
                        <Popconfirm
                          placement="topRight"
                          title="Are you sure you want to send this purchase indent for approval?"
                          onConfirm={() => {
                            updateState({ currentUpdate: 'SENT_FOR_APPROVAL' });
                            updatePIStatus({
                              body: {
                                status: 'SENT_FOR_APPROVAL',
                                pi_id: piId,
                              }
                            }, () => {
                              setCall(!call);
                              updateState({ currentUpdate: '', sendForApprovalConfirmation: false });
                            });
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <H3Text
                            text={(
                              <div style={{ width: '55px', textAlign: 'center' }}>
                                {(updatePIStatusLoading && currentUpdate === 'SENT_FOR_APPROVAL')
                                  ? <LoadingOutlined /> : (
                                    <span>Confirm</span>
                                  )}
                              </div>
                            )}
                            onClick={() => updateState({ sendForApprovalConfirmation: true })}
                            className="action-button action-button-big"
                          />
                        </Popconfirm>
                      )}
                      {selectedPurchaseIndent?.status === 'ISSUED' && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) && (
                        <Popconfirm
                          placement="topRight"
                          title="Are you sure you want to mark the purchase indent as completed?"
                          onConfirm={() => {
                            updateState({ currentUpdate: 'COMPLETED' });
                            updatePIStatus({
                              body: {
                                status: 'COMPLETED',
                                pi_id: piId,
                              }
                            }, () => {
                              setCall(!call);
                              updateState({ currentUpdate: '' });
                            });
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <H3Text
                            text={(
                              <div style={{ width: '50px', textAlign: 'center' }}>
                                {(updatePIStatusLoading && currentUpdate === 'COMPLETED')
                                  ? <LoadingOutlined /> : (
                                    <span>Close</span>
                                  )}
                              </div>
                            )}
                            className="action-button action-button-big"
                          />
                        </Popconfirm>
                      )}
                      {selectedPurchaseIndent?.status?.toLowerCase() !== 'cancelled' && Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.CREATE, user) && (
                        <Popconfirm
                          placement="topRight"
                          title="Are you sure you want to cancel?"
                          onConfirm={() => {
                            if (!!selectedPurchaseIndent?.reference_purchase_orders?.filter((item) => !['CANCELLED']?.includes(item?.status))?.length) {
                              notification.error({
                                message: 'This Purchase Indent cannot be cancelled as it has linked Purchase Orders.',
                                description: 'Please cancel all open Purchase Orders first.',
                                placement: 'top',
                                duration: 6,
                              });
                            } else {
                              updateState({ currentUpdate: 'CANCELLED' });
                              updatePIStatus({
                                body: {
                                  status: 'CANCELLED',
                                  pi_id: piId,
                                }
                              }, () => {
                                setCall(!call)
                                updateState({ currentUpdate: '' });
                              });
                            }
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <H3Text
                            text={(
                              <div style={{ width: '50px', textAlign: 'center' }}>
                                {(updatePIStatusLoading && currentUpdate === 'CANCELLED')
                                  ? <LoadingOutlined /> : (
                                    <span>Cancel</span>
                                  )}
                              </div>
                            )}
                            className="action-button action-button-big"
                          />
                        </Popconfirm>
                      )}
                      {/* {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.DELETE, user) && selectedPurchaseIndent?.status?.toLowerCase() === 'cancelled' && (
                        <Popconfirm
                          placement="topRight"
                          title="Are you sure you want to delete the purchase indent?"
                          onConfirm={() => {
                            deletePurchaseIndent({
                              tenant_id: selectedPurchaseRequest?.tenant_id,
                              purchase_requisition_id: selectedPurchaseRequest.purchase_requisition_id,
                            }, () => {
                              history.push('/purchase/purchase-indent');
                            });
                          }}
                          okText="Yes"
                          cancelText="No"
                        >
                          <H3Text
                            text={(
                              <div style={{ width: '50px', textAlign: 'center' }}>
                                {deletePILoading ? <LoadingOutlined /> : (
                                  <span>Delete</span>
                                )}
                              </div>
                            )}
                            className="action-button action-button-big"
                          />
                        </Popconfirm>
                      )} */}
                      {window.screen.width > 425 && selectedPurchaseIndent?.status === 'ISSUED' && ((Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user))) && (
                        <Dropdown
                          overlay={(
                            <Menu>
                              {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER,
                                Helpers.permissionTypes.CREATE, user) && selectedPurchaseIndent?.status === 'ISSUED' && (
                                  <Menu.Item>
                                    <H3Text
                                      text={(
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <div>
                                            + Purchase Order
                                          </div>
                                          {!user?.tenant_info?.purchase_config?.sub_modules?.purchase_order?.is_active && (
                                            <Popconfirm
                                              placement="topRight"
                                              title="This feature is not accessible within your current plan to use this feature contact us."
                                              onConfirm={() => window.Intercom('showNewMessage')}
                                              okText="Contact Us"
                                              cancelText="Cancel"
                                            >
                                              <img className="barcode-restrict" style={{ marginLeft: '4px' }} src={Crown} alt="premium" />
                                            </Popconfirm>
                                          )}
                                        </div>
                                      )}
                                      className="hide__in-mobile"
                                      onClick={() => updateState({ createPODrawer: true })}
                                    />
                                  </Menu.Item>
                                )}
                            </Menu>
                          )}
                          trigger={['click']}
                          overlayStyle={{ width: '175px' }}
                          placement="bottomLeft"
                        >
                          <H3Text
                            text={(
                              <div onClick={(e) => e.preventDefault()}>
                                More
                                <CaretDownOutlined />
                              </div>
                            )}
                            className="action-button action-button-big no-right-border"
                          />
                        </Dropdown>
                      )}
                    </div>
                  </div>
                )}
              </div>
              <div className='document-header'>
                <div className='ant-row'>
                  <div className="ant-col-md-24">
                    <H3Text
                      text={(
                        <span>
                          <UserOutlined />
                          {' '}
                          <span>
                            <Link>{`${selectedPurchaseIndent?.created_by_info?.first_name}`}</Link>
                          </span>
                        </span>
                      )}
                      className="document-header__party-name"
                    />
                  </div>

                  <div className="ant-col-md-12">
                    <Tooltip title={selectedPurchaseIndent?.tenant_info?.tenant_name}>
                      <div className="document-header__field">
                        <H3Text text="Location" className="document-header__field-name" />
                        <H3Text text={selectedPurchaseIndent?.tenant_info?.tenant_name?.length > 25 ? `${selectedPurchaseIndent?.tenant_info?.tenant_name?.substring(0, 25)}...` : selectedPurchaseIndent?.tenant_info?.tenant_name} className="document-header__field-value" />
                      </div>
                    </Tooltip>
                  </div>

                  <div className="ant-col-md-12">
                    <Tooltip title={selectedPurchaseIndent?.department_info?.department_name}>
                      <div className="document-header__field">
                        <H3Text text="Department" className="document-header__field-name" />
                        <H3Text text={selectedPurchaseIndent?.department_info?.department_name?.length > 25 ? `${selectedPurchaseIndent?.department_info?.department_name?.substring(0, 25)}...` : selectedPurchaseIndent?.department_info?.department_name} className="document-header__field-value" />
                      </div>
                    </Tooltip>
                  </div>

                  <div className="ant-col-md-12">
                    <div className="document-header__field">
                      <H3Text text="PI Date" className="document-header__field-name" />
                      <H3Text
                        text={selectedPurchaseIndent?.pi_date ? (dayjs(selectedPurchaseIndent.pi_date).format('DD/MM/YYYY')) : '-'}
                        className="document-header__field-value"
                      />
                    </div>
                  </div>

                  {selectedPurchaseIndent?.custom_fields?.length > 0 ? (
                    <ViewCustomFields
                      customFields={selectedPurchaseIndent?.custom_fields?.filter((cf) => cf.is_active)}
                      wrapperClass="document-header__field"
                      labelClass="document-header__field-name"
                      valueClass="document-header__field-value"
                      isHorizontal
                    />
                  ) : ''}
                </div>
              </div>
              <br />
              <PurchaseIndentLines
                piLines={selectedPurchaseIndent?.purchase_indent_lines?.map((item) => ({
                  ...item,
                  lineCustomFields: item?.custom_fields,
                }))}
                selectedPurchaseIndent={selectedPurchaseIndent}
                cfPurchaseIndentLine={selectedPurchaseIndent?.purchase_indent_lines?.[0]?.custom_fields}
                visibleColumns={visibleColumns}
                setVisibleColumns={(data) => updateState({ visibleColumns: data })}
              />

              <div className='view-document__totals-wrapper'>
                <div className="view__document-footer-left">
                  {selectedPurchaseIndent?.remarks && (
                    <div className="view__document-tc" style={{ marginBottom: '10px' }}>
                      <H3Text text="Additional Remarks" className="view__document-tc-title" />
                      <H3Text text={selectedPurchaseIndent?.remarks ? selectedPurchaseIndent?.remarks : ''} className="view__document-tc-body" style={{ padding: '15px', }} />
                    </div>
                  )}
                  <Attachment
                    fileList={fileList}
                    disableCase={getAttachmentByIdLoading || updateAttachmentLoading}
                    labelClassName="orgFormLabel"
                    inputClassName=""
                    containerClassName={!piId ? 'view__document-attachment-drawer' : 'view__document-attachment'}
                    handleFileChange={(value) => handleFileChange(value)}
                    updateEnable={Helpers.getPermission(Helpers.permissionEntities.PURCHASE_INDENT, Helpers.permissionTypes.UPDATE, user)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={`${fixedMenuBar ? 'ant-col-md-8' : 'ant-col-md-7'} ant-col-xs-24`}>
            <div className={`view-right__wrapper ${!isQuickView ? 'is-page-view' : ''}`}>
              {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.READ, user) && selectedPurchaseIndent?.reference_purchase_orders?.length > 0 && (
                <div className="linked-doc__wrapper">
                  <H3Text text="PURCHASE ORDERS" className="linked-doc__title" />
                  {selectedPurchaseIndent?.reference_purchase_orders?.map((item) => (
                    <Link
                      key={item?.po_id}
                      to={`/approval?type=po&id=${item?.po_id}`}
                      target="blank"
                    >
                      <div
                        className="linked-doc__item-header"
                      >
                        <CaretRightOutlined />
                        <div className="linked-doc__item-header-id-status__wrapper">
                          <H3Text text={`PO# ${item?.po_number}`} className="linked-doc__item-header-id" />
                          <div
                            className="linked-doc__item-header-status"
                            style={{ backgroundColor: Helpers.getStatusColor(item?.status)?.color }}
                          >
                            {Helpers.getStatusColor(item?.status)?.text}
                          </div>
                        </div>
                        <H3Text
                          text={MONEY(item?.po_grand_total)}
                          className={`linked-doc__item-header-total ${['VOID', 'REJECTED'].includes(item?.status) ? 'linked-doc__item-header-total-disabled' : ''}`}
                          hideText={isDataMaskingPolicyEnable && isHideCostPrice}
                          popOverMessage={"You don't have access to view total amount"}
                        />
                      </div>
                    </Link>
                  ))}
                </div>
              )}
              <TagSelector
                entityType="PURCHASE_INDENT"
                entityId={piId}
                selectedTags={selectedTags}
                isMultiple
                showSearch
                onChange={(value) => {
                  updateState({ selectedTags: value });
                }}
                placeholder="Select Tags"
              />

              {selectedPurchaseIndent?.status !== 'DRAFT' ? (
                <WorkFlowTimeLine
                  workflowSteps={selectedPurchaseIndent?.workflow_steps || {}}
                  workflowStepId={selectedPurchaseIndent?.workflow_step_id}
                  loading={updatePIWorkflowStepLoading}
                  updateWorkflowStep={(payload, callback) => {
                    updatePIWorkflowStep({ body: payload }, callback);
                  }}
                  HideCase={HideAdhocApprovals()}
                  entityId={piId}
                  entityType="PURCHASE_INDENT"
                  callback={() => {
                    setCall(!call);
                  }}
                />
              ) : ''}

              {selectedPurchaseIndent && (
                <ActivityLog
                  entityId={selectedPurchaseIndent?.pi_id}
                  entityType="purchase_indent"
                  entityName="Purchase Indent"
                />
              )}
            </div>
          </div>
        </div>
      )}
      <Drawer
        open={createPODrawer}
        onClose={() => {
          updateState({ createPODrawer: false });
        }}
        mask
        width={Helpers.getDrawerWidth(1150)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: `${Helpers.getDrawerWidth(1100)}px` }}>
            <H3Text text="Create Purchase Order" className="custom-drawer__title" />
            <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => updateState({ createPODrawer: false })} />
          </div>
        </div>
        <POForm
          selectedPI={{
            ...selectedPurchaseIndent,
            tags: selectedTags,
          }}
          callback={() => {
            this.setState({ createPODrawer: false });
            setCall(!call);
          }}
        />
      </Drawer>
    </div>
  );
};

const mapStateToProps = ({
  UserReducers, AttachmentReducers, GetPurchaseIndent, UpdatePurchaseIndentStatus, PurchaseIndentApprovalWorkflow,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  org: UserReducers.org,
  selectedPurchaseIndent: GetPurchaseIndent.data?.[0],
  getPILoading: GetPurchaseIndent.loading,
  selectedAttachment: AttachmentReducers.selectedAttachment,
  getAttachmentByIdLoading: AttachmentReducers.getAttachmentByIdLoading,
  updateAttachmentLoading: AttachmentReducers.updateAttachmentLoading,
  priceMasking: UserReducers.priceMasking,
  updatePIStatusLoading: UpdatePurchaseIndentStatus.loading,
  updatePIWorkflowStepLoading: PurchaseIndentApprovalWorkflow.loading,
});

const mapDispatchToProps = (dispatch) => ({
  switchBusinessUnit: (tenantId, callback) => dispatch(UserActions.switchBusinessUnit(tenantId, callback)),
  getAttachmentById: (entityId, entityName, callback) => dispatch(
    AttachmentActions.getAttachmentById(entityId, entityName, callback),
  ),
  updateAttachment: (payload, callback) => dispatch(
    AttachmentActions.updateAttachment(payload, callback),
  ),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
  getPurchaseIndent: (payload, callback) => dispatch(GetPurchaseIndent.actions.request(payload, callback)),
  getPurchaseIndentSuccess: (payload, callback) => dispatch(GetPurchaseIndent.actions.success(payload, callback)),
  updatePIStatus: (payload, callback) => dispatch(UpdatePurchaseIndentStatus.actions.request(payload, callback)),
  updatePIWorkflowStep: (payload, callback) => dispatch(PurchaseIndentApprovalWorkflow.actions.request(payload, callback)),
  downloadDocument: (payload, document) => dispatch(AnalyticsActions.downloadDocument(payload, document)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewPurchaseIndent));